<template>
  <div>
    <!-- ✅ Header -->
    <Header />

    <!-- ✅ Background container -->
    <div
      class="thankyou-container"
      :style="{ backgroundImage: 'url(' + bgImage + ')' }"
    >
      <div class="overlay"></div>

      <div class="content">
        <div class="checkmark">✔</div>
        <h1>Registration Complete!</h1>
        <p>
          Congratulations! You have successfully registered for
          <strong>Flag Hunter 2.0</strong>. All the event details and updates
          have been sent to your inbox. Stay tuned and get ready to hunt
          those flags!
        </p>

        <div class="buttons">
          <div class="website">
            <button @click="visitWebsite">Visit Our Website</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "./Header.vue";
import thankyouImg from "@/assets/thankyou.png"; 

export default {
  name: "ThankYouPage",
  components: { Header },
  data() {
    return {
      bgImage: thankyouImg
    };
  },
  methods: {
    visitWebsite() {
      window.open("https://fh2.securiumx.com/", "_blank");
    }
  }
};
</script>

<style scoped>
.thankyou-container {
  position: relative;
  max-width: 1106px;
  margin: 50px auto;
  padding: 100px;
  text-align: center;
  border-radius: 12px;
  font-family: Arial, sans-serif;
  color: #fff;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);

  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  overflow: hidden;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    rgba(0, 0, 0, 0.7),
    rgba(0, 0, 0, 0.5)
  ); /* ✅ gradient overlay */
  z-index: 0;
}

.content {
  position: relative;
  z-index: 1; /* content above overlay */
}

.checkmark {
  font-size: 48px;
  color: #00ff00;
  margin-bottom: 20px;
}

h1 {
  font-size: 32px;
  margin-bottom: 10px;
}

p {
  font-size: 16px;
  margin-bottom: 30px;
  color: #f0f0f0;
  line-height: 1.6;
}

.buttons {
  display: flex;
  justify-content: center;
}

button {
  background-color: #ff3333;
  border: none;
  color: white;
  padding: 12px 24px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  transition: background 0.3s;
}

button:hover {
  background-color: #e50914;
}

/* ✅ Responsive design */
@media (max-width: 768px) {
  .thankyou-container {
    max-width: 95%;
    margin: 20px auto;
    padding: 40px 20px;
    border-radius: 8px;
  }

  .checkmark {
    font-size: 36px;
    margin-bottom: 15px;
  }

  h1 {
    font-size: 24px;
    margin-bottom: 8px;
  }

  p {
    font-size: 14px;
    margin-bottom: 20px;
  }

  button {
    width: 100%;
    font-size: 15px;
    padding: 12px;
  }
}

@media (max-width: 480px) {
  .thankyou-container {
    padding: 30px 15px;
  }

  h1 {
    font-size: 20px;
  }

  p {
    font-size: 13px;
  }
}
</style>
